import { useEffect, useRef } from "react";

function ModalGlobalTopbar({ mostrar, aoFechar, children, botaoRef }) {
  const refModal = useRef(null);

  useEffect(() => {
    function fecharAoClicarFora(evento) {
      if (
        refModal.current &&
        !refModal.current.contains(evento.target) &&
        botaoRef?.current &&
        !botaoRef.current.contains(evento.target)
      ) {
        aoFechar(); // Só fecha se clicou fora do modal e do botão
      }
    }

    if (mostrar) {
      // Aguardar um tick antes de ativar o listener garante que o modal foi renderizado
      const timeoutId = setTimeout(() => {
        document.addEventListener("mousedown", fecharAoClicarFora);
      }, 0);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener("mousedown", fecharAoClicarFora);
      };
    }
  }, [mostrar, aoFechar, botaoRef]);

  if (!mostrar) return null;

  return (
    <div>
      <div ref={refModal}>
        {children}
      </div>
    </div>
  );
}

export default ModalGlobalTopbar;
